import {
  Snowflake,
  Wind,
  Zap,
  Hammer,
  Wrench,
  CalendarCheck,
  FileSignature,
  ClipboardList,
} from "lucide-react";

/**
 * Data layanan SEJUKARA (structured content).
 * Ubah/tambah layanan cukup di array ini — UI otomatis mengikuti.
 * `items` = sub-layanan (chip). `audience` = "b2c" | "b2b" | "both".
 */
export const services = [
  {
    id: "ac",
    icon: Snowflake,
    title: "AC",
    description:
      "Layanan lengkap untuk unit AC: cleaning, service, repair, instalasi, inspeksi, troubleshooting, dan preventive maintenance.",
    items: [
      "AC Cleaning",
      "AC Service",
      "AC Repair",
      "AC Installation",
      "AC Inspection",
      "AC Troubleshooting",
      "Preventive Maintenance",
    ],
    audience: "both",
  },
  {
    id: "hvac",
    icon: Wind,
    title: "HVAC",
    description:
      "Perawatan sistem HVAC untuk fasilitas komersial dan gedung — inspeksi, troubleshooting, ducting, dan distribusi udara.",
    items: [
      "HVAC Maintenance",
      "HVAC Inspection",
      "HVAC Troubleshooting",
      "Ducting",
      "Air Distribution",
      "System Maintenance",
    ],
    audience: "b2b",
  },
  {
    id: "electrical",
    icon: Zap,
    title: "Electrical",
    description:
      "Dukungan kelistrikan untuk sistem AC/HVAC: inspeksi, troubleshooting, instalasi, dan perawatan panel.",
    items: [
      "Electrical Inspection",
      "Electrical Troubleshooting",
      "Electrical Installation",
      "Panel Maintenance",
      "Electrical Maintenance",
      "Support AC/HVAC",
    ],
    audience: "both",
  },
  {
    id: "installation",
    icon: Hammer,
    title: "Installation",
    description:
      "Instalasi AC untuk rumah maupun komersial, relokasi unit, pekerjaan kelistrikan pendukung, dan instalasi sistem.",
    items: [
      "AC Installation",
      "Commercial AC Installation",
      "AC Relocation",
      "Supporting Electrical Work",
      "System Installation",
    ],
    audience: "both",
  },
  {
    id: "service-repair",
    icon: Wrench,
    title: "Service & Repair",
    description:
      "Perbaikan dan penanganan masalah pada unit AC & sistem HVAC agar kembali beroperasi optimal.",
    items: ["AC Service", "AC Repair", "Troubleshooting"],
    audience: "both",
  },
  {
    id: "preventive-maintenance",
    icon: CalendarCheck,
    title: "Preventive Maintenance",
    description:
      "Perawatan berkala yang terencana untuk membantu menjaga performa unit sebelum terjadi gangguan.",
    items: [
      "Pemeriksaan rutin",
      "Cleaning berkala",
      "Condition assessment",
      "Dokumentasi pekerjaan",
      "Maintenance planning",
    ],
    audience: "both",
  },
  {
    id: "maintenance-contract",
    icon: FileSignature,
    title: "Maintenance Contract",
    description:
      "Program perawatan berkala untuk perusahaan yang membutuhkan maintenance rutin dan terjadwal.",
    items: [
      "Scheduled inspection",
      "Cleaning",
      "Preventive maintenance",
      "Condition report",
      "Maintenance history",
    ],
    audience: "b2b",
  },
  {
    id: "survey-assessment",
    icon: ClipboardList,
    title: "Survey & Assessment",
    description:
      "Pemeriksaan kondisi unit dan penilaian kebutuhan maintenance sebelum menentukan layanan dan penawaran.",
    items: ["Pemeriksaan unit", "Penilaian kebutuhan", "Rekomendasi layanan"],
    audience: "both",
  },
];

export default services;
